<template>
<div id="app">
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top" style="background-color:#fff !important">
    <div class="container">
      <div class="start">
        <img src="./assets/label.png" class>
      </div>
      <router-link to="/">
        <h4 class="navbar-brand" style="color:#000;padding-top:5px;margin-bottom:0px">Race<a style="color:red">View</a></h4>
      </router-link>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation" v-on:click="viewMobileMenu">
        <span class="ti-menu"></span>
      </button>
      <div class="navbar-collapse" v-show="viewMobile">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item active">
            <router-link to="/"> <a class="nav-link">Home
                <span class="sr-only">(current)</span>
              </a></router-link>
          </li>
          <li class="nav-item">
            <router-link to="/teams"><a class="nav-link">Załogi</a></router-link>
          </li>
          <li class="nav-item">
            <router-link to="/issues">
              <a class="nav-link">Awarie
              </a>
            </router-link>
          </li>

        </ul>
      </div>
      <div class="end">
        <img src="./assets/end.png" class>
      </div>
    </div>
  </nav>
  <div class="container main">
    <router-view></router-view>
    <vue-progress-bar></vue-progress-bar>
  </div>

</div>
</template>

<script>
export default {
  data() {
    return {
      viewMobile: false
    }
  },
  methods: {
    viewMobileMenu() {
      if (this.viewMobile)
        this.viewMobile = false
      else
        this.viewMobile = true

    }
  },
  created() {
    this.$Progress.start()
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress
        this.$Progress.parseMeta(meta)
      }
      this.$Progress.start()
      next()
    })
    this.$router.afterEach(() => {
      this.$Progress.finish()
    })
  }
}
</script>

<style lang="css">
@import './styles/custom.css';
@import './styles/themify-icons.css';

.navbar{
  padding:0px !important;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
.navbar-brand{
  padding-left:10px;
}
.ti-menu{
  color:#000;
}
.navbar-dark .navbar-toggler{
  color: #000 !important;
  border-color: #000 !important;
}
</style>
